/* jshint node:true */
'use strict';

var React = require('react');

/* Components */
var LeagueTable         = require('./LeagueTable.jsx');
var NewsList            = require('./NewsList.jsx');
var Advert = require('../../common/Advert.jsx');
var AdReloaderMixin = require('../../../mixins/AdReloaderMixin.js');
var utils = require('../../../helpers/utils/index.js');
var PlayerStatsTable = require('./PlayerStatsTable.jsx');

var Glossary = React.createClass({
    render : function(){
        return (
            <div className="sub-module">
                <div className="glossary comp">
                    <h3>Glossary</h3>
                    <ul>
                        <li dangerouslySetInnerHTML={{__html: '<span>T: </span>Tries'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>A: </span>Try Assists'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>Pts: </span>Points Scored'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>K: </span>Kicks'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>P: </span>Passes'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>R: </span>Runs'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>MR: </span>Metres Run with ball'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>CB: </span>Clean Breaks'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>DB: </span>Defenders Beaten'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>OL: </span>Offloads'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>LS: </span>Lineouts Stolen'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>TC: </span>Turnovers Conceded'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>Tack: </span>Tackles'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>MT: </span>Missed Tackles'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>LO: </span>Lineouts won on throw'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>Pen: </span>Penalties conceded'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>Y: </span>Yellow Cards'}}></li>
                        <li dangerouslySetInnerHTML={{__html: '<span>R: </span>Red Cards'}}></li>
                    </ul>
                </div>
            </div>
        );
    }
});

var TabPlayerStats = React.createClass({

    displayName: 'TabPlayerStats',
    
    mixins : [ AdReloaderMixin ],
    
    getInitialState : function(){
        return {
            adWrapSelector : '#reactContainer .react-ad'
        };
    },

    render: function () {

        var sState = this.props.matchState || 'pre'; //pre,post,live
        var oStore = this.props.store;
        var rSummary = null;
        
        /* Load in the data from the Store */
        var aLeagueTable = oStore.getLeagueTable();
        var leagueName = oStore.getLeagueName();
        var newsList = oStore.getNewsList();
        var gameStripProps = oStore.getGameStripDetails();
        var homeLogo = utils.getImageUrl(gameStripProps.teams.home.logo);
        var awayLogo = utils.getImageUrl(gameStripProps.teams.away.logo);
        var homeTeam = {logo: homeLogo, abbreviation: gameStripProps.teams.home.abbreviation};
        var awayTeam = {logo: awayLogo, abbreviation: gameStripProps.teams.away.abbreviation};

        return (
            <div className="layout-bc">
                <section className="col-b">
                    <PlayerStatsTable home={homeTeam} away={awayTeam} store={oStore} />
                    <Glossary />
                </section>
                <section className="col-c">
                    <article className="ad-300">
                        <div className="ad-center">
                            <Advert id='game.rhs.mpu' className="ad-slot-incontent ad-wrapper" slotType="incontent" />
                        </div>
                    </article>
                    <LeagueTable tableHref={this.props.tableHref} date="" name={leagueName} table={aLeagueTable} />
                    <NewsList header={newsList.header} link={newsList.link} articles={newsList.articles} />
                </section>
            </div>
        );
    }
});

module.exports = TabPlayerStats;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/TabPlayerStats.jsx
 **/